<template>
  <layout
    title="404"
    :banner="$page.props.banner"
    h1="404"
  >
    <section id="404-content">
      <div class="scol-section bg-light">
        <div class="container">
          <div class="text-center">
          <h2 class="text-secondary">
            Diese Seite konnte nicht gefunden werden.
          </h2>
            <a href="/" class="btn btn-primary rounded-pill mt-5" title="Startseite"
              >Zurück zur Startseite</a
            >
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";

export default {
  components: {
    Layout,
  },
};
</script>
